import { memo, useState } from 'react';
import { Dialog } from '@robocorp/components';
import { Outlet, useNavigate } from 'react-router-dom';
import { withErrorBoundary } from '~/hocs';
import WorkItems from './WorkItems';

const PREVIOUS_PAGE = -1;

const Content = () => {
  const [createItemOpen, setCreateItemOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  return (
    <Dialog size="x-large" onClose={() => navigate(PREVIOUS_PAGE)} open>
      <>
        <WorkItems createItemOpen={createItemOpen} setCreateItemOpen={setCreateItemOpen} />
        <Outlet />
      </>
    </Dialog>
  );
};

export const DataExplorer = withErrorBoundary(memo(Content));
